import React from 'react'

// Datos de características y disponibilidad en cada plan
const features = [
  { name: 'Creación de Redes Sociales', basic: true, pro: true, business: true },
  { name: 'Plan y Estrategia para redes sociales', basic: false, pro: true, business: true },
  { name: 'Diseño de Contenidos post o stories', basic: true, pro: true, business: true },
  { name: 'Carnadas de Venta', basic: false, pro: true, business: true },
  { name: 'Textos publicitarios', basic: true, pro: true, business: true },
  { name: 'Programación de contenido', basic: false, pro: false, business: true },
  { name: 'Automatización de mensajes y comentarios', basic: false, pro: false, business: true },
  { name: 'Reportes', basic: false, pro: false, business: true },
  { name: 'Soporte 24/7', basic: false, pro: true, business: true },
];

// Componente para el ícono de check
const CheckIcon = () => (
  <span className="w-5 h-5 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0">
    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" className="w-3 h-3" viewBox="0 0 24 24">
      <path d="M20 6L9 17l-5-5"></path>
    </svg>
  </span>
);

// Componente para el ícono de X
const XIcon = () => (
  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" className="w-5 h-5 text-gray-500" viewBox="0 0 24 24">
    <path d="M18 6L6 18M6 6l12 12"></path>
  </svg>
);

const Planes = () => {
  return (
    <section className="text-gray-700 body-font overflow-hidden border-t border-gray-200">
      <div className="container px-5 py-24 mx-auto flex flex-wrap">
        {/* Encabezado */}
        <div className="flex flex-col text-center w-full mb-20">
          <h2 className="text-xs text-cyan-700 tracking-widest font-medium title-font mb-1">#ADAPTABLE</h2>
          <h1 className="sm:text-3xl text-2xl font-medium title-font text-gray-900">Nuestros Planes</h1>
        </div>

        {/* Columna de características */}
        <div className="lg:w-1/4 mt-48 hidden lg:block">
          <div className="mt-px border-t border-gray-300 border-b border-l rounded-tl-lg rounded-bl-lg overflow-hidden">
            {features.map((feature, index) => (
              <p key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : ''} text-gray-900 h-12 px-4 flex items-center justify-start`}>
                {feature.name}
              </p>
            ))}
          </div>
        </div>

        {/* Planes */}
        <div className="flex lg:w-3/4 w-full flex-wrap lg:border border-gray-300 rounded-lg">

          {/* Plan Básico */}
          <div className="lg:w-1/3 lg:mt-px w-full mb-10 lg:mb-0 border-2 border-gray-300 lg:border-none rounded-lg lg:rounded-none">
            <div className="px-2 text-center h-48 flex flex-col items-center justify-center">
              <h3 className="tracking-widest">BÁSICO</h3>
              <h2 className="text-5xl text-gray-900 font-medium flex items-center justify-center leading-none mb-4 mt-2">
                $19<span className="text-gray-600 text-base ml-1">/mes</span>
              </h2>
              <span className="text-sm text-gray-600">Cobrando $200 por año</span>
            </div>
            <p className="bg-gray-100 text-gray-600 h-12 text-center px-2 flex items-center -mt-px justify-center border-t border-gray-300">
              Incluido
            </p>
            {features.map((feature, index) => (
              <p key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : ''} h-12 flex items-center justify-center`}>
                {feature.basic ? <CheckIcon /> : <XIcon />}
              </p>
            ))}
            <div className="border-t border-gray-300 p-6 text-center rounded-bl-lg">
              <button className="flex items-center mt-auto text-white bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400 border-0 py-2 px-4 w-full focus:outline-none hover:from-cyan-400 hover:via-blue-600 hover:to-blue-900 rounded-full transition-colors duration-300">
                Comprar
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </button>
              <p className="text-xs text-gray-500 mt-3">Contenido puede variar de cuerdo a la necesidad, previamente asesorado.</p>
            </div>
          </div>

          {/* Plan Pro */}
          <div className="lg:w-1/3 lg:-mt-px w-full mb-10 lg:mb-0 border-2 rounded-lg border-cyan-700 relative">
            <span className="bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">POPULAR</span>
            <div className="px-2 text-center h-48 flex flex-col items-center justify-center">
              <h3 className="tracking-widest">PRO</h3>
              <h2 className="text-5xl text-gray-900 font-medium flex items-center justify-center leading-none mb-4 mt-2">
                $38<span className="text-gray-600 text-base ml-1">/mes</span>
              </h2>
              <span className="text-sm text-gray-600">Cobrando $456 por año</span>
            </div>
            <p className="bg-gray-100 text-gray-600 h-12 text-center px-2 flex items-center -mt-px justify-center border-t border-gray-300">
              Incluido
            </p>
            {features.map((feature, index) => (
              <p key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : ''} h-12 flex items-center justify-center`}>
                {feature.pro ? <CheckIcon /> : <XIcon />}
              </p>
            ))}
            <div className="p-6 text-center border-t border-gray-300">
              <button className="flex items-center mt-auto text-white bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400 border-0 py-2 px-4 w-full focus:outline-none hover:from-cyan-400 hover:via-blue-600 hover:to-blue-900 rounded-full transition-colors duration-300">
                Comprar
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </button>
              <p className="text-xs text-gray-500 mt-3">Contenido puede variar de cuerdo a la necesidad, previamente asesorado.</p>
            </div>
          </div>

          {/* Plan Business */}
          <div className="lg:w-1/3 w-full lg:mt-px border-2 border-gray-300 lg:border-none rounded-lg lg:rounded-none">
            <div className="px-2 text-center h-48 flex flex-col items-center justify-center">
              <h3 className="tracking-widest">BUSINESS</h3>
              <h2 className="text-5xl text-gray-900 font-medium flex items-center justify-center leading-none mb-4 mt-2">
                $54<span className="text-gray-600 text-base ml-1">/mes</span>
              </h2>
              <span className="text-sm text-gray-600">Cobrando $648 por año</span>
            </div>
            <p className="bg-gray-100 text-gray-600 h-12 text-center px-2 flex items-center -mt-px justify-center border-t border-gray-300">
              Incluido
            </p>
            {features.map((feature, index) => (
              <p key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : ''} h-12 flex items-center justify-center`}>
                {feature.business ? <CheckIcon /> : <XIcon />}
              </p>
            ))}
            <div className="p-6 text-center border-t border-gray-300">
              <button className="flex items-center mt-auto text-white bg-gradient-to-r from-blue-900 via-blue-600 to-cyan-400 border-0 py-2 px-4 w-full focus:outline-none hover:from-cyan-400 hover:via-blue-600 hover:to-blue-900 rounded-full transition-colors duration-300">
                Comprar
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </button>
              <p className="text-xs text-gray-500 mt-3">Contenido puede variar de cuerdo a la necesidad, previamente asesorado.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Planes
